import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import NoResult from 'containers/notification-center/NoResult';
import { Loading, I18NContext, I18N, I18NConsumer, GlobalContext, EBPagination } from 'commons';
import { baseUrl, orgId, Ajax, setPageTitle, getUrlParams } from 'utils';
import Item from './Item';

const NotificationList = () => {

  const i18n = useContext(I18NContext);
  const { organization: { orgName }, onPaginationChange,
    pageNo,
    pageSize } = useContext(GlobalContext);
  const [notificationList, setNotificationList] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [err, setErr] = useState(null)
  const [pageTotal, setPageTotal] = useState(110)

  const request = (page = 1, pageSize = 25) => {
    const url = `/rest/notif/page?orgId=${orgId}`;
    setIsLoading(true)
    Ajax.get(url, {
      params: {
        'pageNo': page,
        'pageSize': pageSize
      }
    }).then(({ data }) => {
      setNotificationList(data.data)
      setPageTotal(data.count)
      setErr(data.message)
      setIsLoading(false)
    }).catch(err => {
      setErr(err)
      setIsLoading(false)
    });
  }

  useEffect(() => {
    if (pageNo && pageSize) {
      request(pageNo, pageSize)
    } else {
      request()
    }
  }, []);

  const updatePagination = (pageNo, pageSize) => {
    request(pageNo, pageSize)

    // Change the state of pagination in context
    onPaginationChange(pageNo, pageSize)
  }

  return (
    <div className="notification-list">
      <I18NConsumer>
        {() => setPageTitle(`${orgName} - ${i18n['notification.title.text']}`)}
      </I18NConsumer>
      {
        (isLoading || !notificationList) && <Loading />
      }
      {
        !isLoading && notificationList &&
        <div>
          {(notificationList.length > 0 ? (
            notificationList.map((notification, index) => (
              <Item notification={notification} index={index} key={notification.notificationId} pagination={{ pageNo: pageNo, pageSize: pageSize }} />
            ))
          ) : <NoResult message="notification.list.empty" />)}
        </div>
      }
      {
        !isLoading && notificationList && notificationList.length > 0 &&
        <div className="text-center">
          <EBPagination
            showTotal={(total, range) => <I18N>{`event.table.pagination.pageInfo,${range[0]},${range[1]}, ${total}`}</I18N>}
            defaultCurrent={1}
            total={pageTotal}
            onChange={(page, pageSize) => updatePagination(page, pageSize)}
            pageSize={pageSize}
            current={pageNo}
          />
        </div>
      }
    </div>
  );
};

NotificationList.propTypes = {
};

export default NotificationList;
